<template>
  <form class="comment-form panel" @submit.prevent="submit">
    <h2>Добавить комментарий</h2>

    <label class="form-field">
      <span>Текст</span>
      <textarea v-model="body" rows="3" placeholder="Комментарий"></textarea>
    </label>

    <label v-if="!textOnly" class="form-field">
      <span>Фото</span>
      <input
        ref="fileInput"
        type="file"
        accept="image/jpeg,image/png,image/webp"
        multiple
        @change="onFilesSelected"
      />
    </label>

    <div v-if="!textOnly" class="btn-row">
      <button
        type="button"
        class="btn"
        :class="pickPointMode ? 'btn-danger' : 'btn-secondary'"
        @click="togglePickPoint"
      >
        {{ pickPointMode ? 'Отменить привязку' : 'Указать на карте' }}
      </button>
      <button
        v-if="pickedPoint"
        type="button"
        class="btn btn-secondary"
        @click="clearPoint"
      >
        Сбросить точку
      </button>
    </div>

    <p v-if="!textOnly && pickedPoint" class="comment-picked-point">
      Точка: {{ pickedPoint.lat.toFixed(5) }}, {{ pickedPoint.lng.toFixed(5) }}
    </p>

    <p v-if="error" class="error-message">{{ error }}</p>

    <button class="btn" type="submit" :disabled="submitting || !canSubmit">
      {{ submitting ? 'Отправка...' : 'Отправить' }}
    </button>
  </form>
</template>

<script setup>
import { computed, ref } from 'vue'

const props = defineProps({
  textOnly: {
    type: Boolean,
    default: false,
  },
  pickPointMode: {
    type: Boolean,
    default: false,
  },
  pickedPoint: {
    type: Object,
    default: null,
  },
  submitting: {
    type: Boolean,
    default: false,
  },
  error: {
    type: String,
    default: '',
  },
})

const emit = defineEmits(['submit', 'toggle-pick-point', 'clear-point'])

const body = ref('')
const files = ref([])
const fileInput = ref(null)

const canSubmit = computed(() => {
  if (props.textOnly) {
    return body.value.trim().length > 0
  }
  return body.value.trim().length > 0 || files.value.length > 0
})

function onFilesSelected(event) {
  files.value = Array.from(event.target.files || [])
}

function togglePickPoint() {
  emit('toggle-pick-point')
}

function clearPoint() {
  emit('clear-point')
}

function submit() {
  const formData = new FormData()

  if (body.value.trim()) {
    formData.append('body', body.value.trim())
  }

  if (!props.textOnly && props.pickedPoint) {
    formData.append('lat', props.pickedPoint.lat)
    formData.append('lng', props.pickedPoint.lng)
  }

  if (!props.textOnly) {
    files.value.forEach((file) => {
      formData.append('photos[]', file)
    })
  }

  emit('submit', formData, {
    reset: () => {
      body.value = ''
      files.value = []
      if (fileInput.value) {
        fileInput.value.value = ''
      }
    },
  })
}
</script>

<style scoped>
.comment-form textarea {
  border: 1px solid #cbd5e1;
  border-radius: 0.5rem;
  padding: 0.625rem 0.75rem;
  resize: vertical;
}

.comment-picked-point {
  margin: 0 0 0.75rem;
  font-size: 0.875rem;
  color: #64748b;
}
</style>
